import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import './ProfileSettings.scss';
import {
  RESET_LABEL,
  ACC_DETAILS_LABEL,
  ACC_DETAILS,
  SETTINGS_TEXT,
  LOADING_TEXT,
  CANCEL_TEXT,
  CHOOSE_PASSWORD_TEXT,
  PASSWORD_NO_MATCH,
  PASSWORD_CHAR,
  PASSWORD_MIN,
  PASSWORD_ERROR,
  OLD_PASSWORD_ERROR,
  CHOOSE_PASSWORD_DESCRIBE,
  PASSWORD_REP,
  OLD_PASSWORD_SAME,
  PASSWORD_SP_ERROR,
  PASSWORD_NUMBER_REQ,
} from '../../../constants/settingsPageConstants';
import Account from '../../../../public/assets/img/Account.svg';
import { useDispatch, useSelector } from 'react-redux';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import checkedIcon from '../../../../public/assets/img/checked.svg';
import unCheckedIcon from '../../../../public/assets/img/unchecked.svg';
import { emailAddressSaga, resetPasswordStatusSaga, usernameSaga } from '../../../redux/saga/loginServiceSelector';
import { RESET_PASSWORD } from '../../../constants/buttonConstants';
import { Alert, CircularProgress, Dialog, DialogContent, DialogTitle, InputAdornment, Snackbar, TextField } from '@mui/material';
import { clearResetPasswordStatus, loadingInProgress, resetPasswordRequest } from '../../../redux/actions/loginServiceAction';
import { useNavigate } from 'react-router-dom';
import { RESET_PASSWORD_UPDATED_DESC2, SUB_UNSUSS_DES } from '../../../constants/merchantsConstants';
import { checkForRepeatedSequence, onlySpecialCharaAllowed, restrictOnlyFewSpecialChara, containsAtleastOneNumber } from '../../../shared/utils/format.helpers';
import {encryptPassword} from '../../../shared/utils/common';

export default function ProfileSettings() {
	
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const userName = useSelector(usernameSaga);
	const userEmail = useSelector(emailAddressSaga);
	const resetPasswordStatus = useSelector(resetPasswordStatusSaga);
	const [popupTitle, setpopupTitle] = useState('');
	const [primaryButtonText, setprimaryButtonText] = useState('');
	const [openResetPopOver, setOpenResetPopOver] = useState(false);
	const [openNotification, setOpenNotification] = useState(false);
	const [loading, setLoading] = useState(true);
	const [popOverState, setPopOverState] = useState(0);
	const [descriptionContent, setDescriptionContent] = useState('');
	const [confirmpasswordError, setconfirmpasswordError] = useState(false);
	const [oldpasswordError, setOldPasswordError] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [formValid, setformValid] = useState(false);
	const [formData, setformData] = useState({
		fields: {
		oldpassword: '',
		password: '',
		confirmpassword: '',
		},
		errors: {},
	});
	const [confirmpasswordErrorIcon, setconfirmpasswordErrorIcon] = useState(null);
	const [passwordErrorIcon, setpasswordErrorIcon] = useState(false);
	const [oldpasswordErrorIcon, setOldPasswordErrorIcon] = useState(false);
	const [miniCharaCheckIcon, setminiCharCheckIcon] = useState(unCheckedIcon);
	const [specialCharaCheckIcon, setspecialCharaCheckIcon] = useState(unCheckedIcon);
	const [noRepCharaCheckIcon, setNoRepCharaCheckIcon] = useState(unCheckedIcon);
	const [containsNumberCheckIcon, setContainsNumberCheckIcon] = useState(unCheckedIcon);
	const [resetStatus, setResetStatus] = useState(false);

	useEffect(() => {
		if (resetPasswordStatus) {
		setPopOverState(0);
		dispatch(loadingInProgress(false));
		setOpenResetPopOver(false);
		setOpenNotification(true);
		setTimeout(() => {
			setOpenNotification(false);
			dispatch(clearResetPasswordStatus());
		}, 2000);
		if (resetPasswordStatus?.msg) {
			// console.log('resetPasswordStatus => ', resetPasswordStatus, resetPasswordStatus?.msg);
			setResetStatus(false);
		} else {
			setResetStatus(true);
		}
		}
	}, [resetPasswordStatus]);

	const resetClickHandler = () => {
		if (popOverState === 0) {
			resetInitPopOver();
			setspecialCharaCheckIcon(unCheckedIcon);
			setNoRepCharaCheckIcon(unCheckedIcon);
			setminiCharCheckIcon(unCheckedIcon);
			setpasswordErrorIcon(null);
			setconfirmpasswordErrorIcon(null);
			setOldPasswordErrorIcon(null);
			setPasswordError(false);
			setconfirmpasswordError(false);
			setOldPasswordError(false);
			setformData({
				fields: {
				oldpassword: '',
				password: '',
				confirmpassword: '',
				},
				errors: {},
			});
			setOpenResetPopOver(true);
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		}
	};

	const resetInitPopOver = () => {
		setPopOverState(1);
		setpopupTitle(CHOOSE_PASSWORD_TEXT);
		setDescriptionContent(CHOOSE_PASSWORD_DESCRIBE);
		setprimaryButtonText(RESET_PASSWORD);
	};

	const handleClose = () => {
		setOpenResetPopOver(false);
		setPopOverState(0);
	};

	const primaryButtonEvent = (e) => {
		e.preventDefault();

		if (formValid) {
		dispatch(loadingInProgress(true));
			
		const oldPassword = encryptPassword(formData.fields.oldpassword);
		const updatedPassword = encryptPassword(formData.fields.password);
		dispatch(resetPasswordRequest(oldPassword, updatedPassword));
		}
	};

	const handleChange = (e) => {
		let fields = formData.fields;
		let errors = formData.errors;
		fields[e.target.id] = e.target.value;
		if (e.target.id === 'oldpassword') {
			// console.log('OLD ', restrictOnlyFewSpecialChara(formData.fields.oldpassword), checkForRepeatedSequence(formData.fields.oldpassword));
			if (formData.fields.oldpassword === '' || !restrictOnlyFewSpecialChara(formData.fields.oldpassword) || !checkForRepeatedSequence(formData.fields.oldpassword)) {
				setOldPasswordError(true);
				setOldPasswordErrorIcon(WarningTriangle);
				errors[e.target.id] = OLD_PASSWORD_ERROR;
			} else {
				setOldPasswordError(false);
				setOldPasswordErrorIcon(null);
				delete errors[e.target.id];
			}
		}

		if (e.target.id === 'password') {
			// console.log('CHECK ', formData.fields.password.length, (formData.fields.password.length < 14 || formData.fields.password.length > 20), regExpSpecialChara.test(formData.fields.password))
			if (
				formData.fields.password === '' ||
				formData.fields.password.length < 14 ||
				formData.fields.password.length > 20 ||
				!restrictOnlyFewSpecialChara(formData.fields.password) ||
				!checkForRepeatedSequence(formData.fields.password) || 
				!containsAtleastOneNumber(formData.fields.password)
			) {
				setPasswordError(true);
				setpasswordErrorIcon(WarningTriangle);
				setminiCharCheckIcon(unCheckedIcon);
				errors[e.target.id] = !checkForRepeatedSequence(formData.fields.password) ? PASSWORD_SP_ERROR : !restrictOnlyFewSpecialChara(formData.fields.password) ? PASSWORD_SP_ERROR : PASSWORD_ERROR;
			} else {
				if (restrictOnlyFewSpecialChara(formData.fields.password) && formData.fields.password.length >= 14) {
				setPasswordError(false);
				setpasswordErrorIcon(null);
				delete errors[e.target.id];
				}
			}
			onlySpecialCharaAllowed(formData.fields.password) ? setspecialCharaCheckIcon(checkedIcon) : setspecialCharaCheckIcon(unCheckedIcon);

			checkForRepeatedSequence(formData.fields.password) ? setNoRepCharaCheckIcon(checkedIcon) : setNoRepCharaCheckIcon(unCheckedIcon);
			containsAtleastOneNumber(formData.fields.password) ? setContainsNumberCheckIcon(checkedIcon) : setContainsNumberCheckIcon(unCheckedIcon);

			formData.fields.password.length >= 14 && formData.fields.password.length <= 20 ? setminiCharCheckIcon(checkedIcon) : setminiCharCheckIcon(unCheckedIcon);

			if (formData.fields.password === formData.fields.confirmpassword) {
				setconfirmpasswordError(false);
				setconfirmpasswordErrorIcon(null);
				delete errors['confirmpassword'];
			} else {
				if (formData.fields.confirmpassword.length >= 14) {
				setconfirmpasswordErrorIcon(WarningTriangle);
				setconfirmpasswordError(true);
				errors['confirmpassword'] = 'Password do not match';
				}
			}
		}

		if (e.target.id === 'confirmpassword') {
			if (formData.fields.confirmpassword === '' && formData.fields.confirmpassword.length <= 14) {
				setconfirmpasswordErrorIcon(WarningTriangle);
				setconfirmpasswordError(true);
				errors['confirmpassword'] = PASSWORD_ERROR;
			} else {
				if (formData.fields.password === formData.fields.confirmpassword) {
				setconfirmpasswordError(false);
				setconfirmpasswordErrorIcon(null);
				delete errors['confirmpassword'];
				} else {
				if (formData.fields.confirmpassword.length >= 14) {
					setconfirmpasswordErrorIcon(WarningTriangle);
					setconfirmpasswordError(true);
					errors['confirmpassword'] = PASSWORD_NO_MATCH;
				}
				}
			}
		}
		// console.log('CHECK OLD ',formData.fields.oldpassword,'PASSWORD ',formData.fields.password)
		if(formData.fields.oldpassword.length > 0 && formData.fields.password.length > 0 && formData.fields.oldpassword === formData.fields.password){
			setPasswordError(true);
			setpasswordErrorIcon(WarningTriangle);
			errors['password'] = OLD_PASSWORD_SAME;
		}
		setformData({ ...formData });
	};

	useEffect(() => {
		setformValid(
		formData.fields.oldpassword.length > 0 &&
			formData.fields.password.length > 0 &&
			formData.fields.confirmpassword.length > 0 &&
			formData.fields.password === formData.fields.confirmpassword &&
			!oldpasswordError &&
			!passwordError &&
			!confirmpasswordError &&
			checkForRepeatedSequence(formData.fields.password) &&
			restrictOnlyFewSpecialChara(formData.fields.password) &&
			onlySpecialCharaAllowed(formData.fields.password) &&
			oldpassword !== password
		);
		// console.log('ERRORs ',oldpasswordError, passwordError, confirmpasswordError)
	}, [formData.fields, oldpasswordError, passwordError, confirmpasswordError]);

	return (
		<div className='settings-container'>
			<Paper className='page-header'>
				<h4 className='title' data-testid='profile-settings'>
				{SETTINGS_TEXT}
				</h4>
			</Paper>
			<Paper className='settings-body'>
				<b>{ACC_DETAILS}</b>
				<br></br>
				<span>{ACC_DETAILS_LABEL}</span>
			</Paper>
			<Paper className='settings-body-content'>
				<div className='profile-section'>
				<div>
					<img src={Account} alt='account-icon' />
				</div>
				<div className='profile-section-details'>
					<span>{userName}</span>
					<br></br>
					<span className='userEmail'>{userEmail}</span>
				</div>
				</div>
				<div>
				<button variant='outlined' className='password-button' onClick={() => resetClickHandler()}>
					{RESET_LABEL}
				</button>
				</div>
			</Paper>

			<Dialog
				className='dialog-cont'
				sx={{
				borderRadius: '20px',
				'& .MuiDialog-paper': {
					borderRadius: '16px',
					minWidth: '40vw',
					maxWidth: '50vw',
					maxHeight: '60vh',
				},
				margin: '0 auto',
				}}
				slotProps={{ dialog: { backgroundColor: 'red' } }}
				onClose={handleClose}
				open={openResetPopOver}
			>
				{loading && open ? (
				<>
					<DialogTitle>{LOADING_TEXT}</DialogTitle>

					<div className='dialog-cont--loading'>
					<CircularProgress />
					</div>
				</>
				) : (
				<>
					<DialogTitle className='reset-pop-over--container--title '>{popupTitle}</DialogTitle>

					<DialogContent className='reset-pop-over--container--sub-text'>
					{descriptionContent}

					{popOverState === 1 ? (
						<form className='reset-pop-over--container--form-cont' autoComplete='off' onSubmit={(e) => primaryButtonEvent(e)}>
						<TextField
							id='oldpassword'
							data-testid='oldpassword'
							label='Old Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Old Password'
							error={oldpasswordError}
							helperText={formData.errors?.oldpassword}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: <InputAdornment position='end'>{formData.errors?.oldpassword ? <img src={oldpasswordErrorIcon} className='error-icon' /> : null}</InputAdornment>,
							}}
						/>
						<TextField
							id='password'
							data-testid='password'
							label='Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Password'
							error={passwordError}
							helperText={formData.errors?.password}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: <InputAdornment position='end'>{formData.errors?.password ? <img src={passwordErrorIcon} className='error-icon' /> : null}</InputAdornment>,
							}}
							FormHelperTextProps={{
							className: 'helper-text-class',
							}}
						/>
						<TextField
							id='confirmpassword'
							data-testid='confirmpassword'
							label='Confirm Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Confirm Password'
							error={confirmpasswordError}
							helperText={formData.errors?.confirmpassword}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: <InputAdornment position='end'>{formData.errors?.confirmpassword ? <img src={confirmpasswordErrorIcon} className='error-icon' /> : null}</InputAdornment>,
							}}
							FormHelperTextProps={{
							className: 'helper-text-class',
							}}
						/>
						</form>
					) : null}
					<div className='check-item'>
						<img className='check-img' src={miniCharaCheckIcon} />
						<p className='check-text'>{PASSWORD_MIN}</p>
					</div>
					<div className='check-item'>
						<img className='check-img' src={specialCharaCheckIcon} />
						<p className='check-text'>{PASSWORD_CHAR}</p>
					</div>
					<div className='check-item'>
						<img className='check-img' src={containsNumberCheckIcon} />
						<p className='check-text'>{PASSWORD_NUMBER_REQ}</p>
					</div>
					<div className='check-item'>
						<img className='check-img' src={noRepCharaCheckIcon} />
						<p className='check-text'>{PASSWORD_REP}</p>
					</div>
					</DialogContent>
					<div className='reset-pop-over--container--alignright reset-pop-over--container__buttongroup'>
					<button className='reset-pop-over--container--alignright__button reset-pop-over--container--alignright--secondaryButton' onClick={() => handleClose()}>
						{CANCEL_TEXT}
					</button>
					<button className='reset-pop-over--container--alignright__button reset-pop-over--container--alignright--primaryButton' data-testid='confirmresetpassword' disabled={!formValid} onClick={(e) => primaryButtonEvent(e)}>
						{primaryButtonText}
					</button>
					</div>
				</>
				)}
			</Dialog>

			<Snackbar
				autoHideDuration={1800}
				open={openNotification}
				onClose={() => setOpenNotification(false)}
				anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
				}}
				sx={{ position: 'absolute' }}
			>
				<Alert onClose={() => setOpenNotification(false)} severity={resetStatus === true && resetPasswordStatus ? 'success' : 'error'} variant='filled' sx={{ width: '100%' }}>
				{resetStatus === false && resetPasswordStatus ? <>{SUB_UNSUSS_DES}</> : resetStatus === true && resetPasswordStatus ? <>{RESET_PASSWORD_UPDATED_DESC2}</> : null}
				</Alert>
			</Snackbar>
		</div>
	);
}
